import { Account, AccountType } from '@reward-platform/ancillaries-schemas/accounts'
import { nextApiClient } from './clients/nextApiClient'

export async function getAccount(accountType: AccountType): Promise<Account> {
  const { data } = await nextApiClient.get<Account>(`/user/accounts`, {
    params: {
      accountType,
    },
  })

  return data
}

export async function getIsHouseholdAccount(): Promise<boolean> {
  const { data } = await nextApiClient.get<{ isHouseholdAccount: boolean }>(`/user/household`)

  return data.isHouseholdAccount
}
